(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/models/tipset-actionbar.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/models/tipset-actionbar.js'); (function(Backbone, _, svs) {
  'use strict';

  svs.tipset.models.TipsetActionbar = Backbone.Model.extend({
    log: new svs.core.log.Logger('svs.models.TipsetActionbar'),
    defaults: {},

    initialize: function() {
      this.listenTo(
        svs.tipset.models.play,
        'change:isSingleRow',
        this.clearAll
      );
      this.listenTo(svs.tipset.models.systems, 'change', this.setSystem);
      this.listenTo(
        svs.tipset.models.xpertenSystems,
        'sync generateSystem resetXperten change:quickPick',
        this.setXperten
      );
      this.listenTo(
        svs.tipset.models.xpertenSystemsSingleRow,
        'sync generateSystem resetXperten, change:quickPick',
        this.setXperten
      );
      this.listenTo(
        svs.tipset.models.xpertenSystems,
        'resetXperten',
        this.clearAll
      );
      this.listenTo(
        svs.tipset.models.xpertenSystemsSingleRow,
        'resetXperten',
        this.clearAll
      );
      if (
        !svs.tipset.models.play.get('isSingleRow') &&
        svs.tipset.models.systems &&
        svs.tipset.models.systems.getCurrentSystem()
      ) {
        this.setSystem();
      }
    },

    setSystem: function() {
      var system, systemName, eventName;
      if (svs.tipset.models.systems.get('showActionbar')) {
        if (
          !(
            svs.tipset.models.competition &&
            svs.tipset.models.competition.getCompetitionMode()
          )
        ) {
          system = svs.tipset.models.systems.getCurrentSystem();
          systemName = svs.tipset.models.systems.getSystemName();
          eventName = 'showActionBarSystem';

          this.set({
            systemName: systemName,
            system: system
          });

          if (!system) {
            eventName = 'removeActionBar';
          }
        } else {
          eventName = 'removeActionBar';
        }

        this.trigger(eventName);
      }
    },

    setXperten: function() {
      var isSingleRow = svs.tipset.models.play.get('isSingleRow'),
        xperten,
        hasXperten = false;

      if (isSingleRow) {
        hasXperten =
          svs.tipset.models.xpertenSystemsSingleRow &&
          svs.tipset.models.xpertenSystemsSingleRow.getCurrentSystem();
        xperten =
          hasXperten &&
          svs.tipset.models.xpertenSystemsSingleRow.showActionbar()
            ? svs.tipset.models.xpertenSystemsSingleRow.getCurrentSystem()
            : undefined;
      } else {
        hasXperten =
          svs.tipset.models.xpertenSystems &&
          svs.tipset.models.xpertenSystems.getCurrentSystem();
        xperten =
          hasXperten && svs.tipset.models.xpertenSystems.showActionbar()
            ? svs.tipset.models.xpertenSystems.getCurrentSystem()
            : undefined;
      }

      if (xperten) {
        if (isSingleRow) {
          this.setXpertenSingleRow(xperten);
        } else {
          this.setXpertenNormal(xperten);
        }
        this.updateXpertSystem();
      }
    },

    setXpertenSingleRow: function(xperten) {
      var generateSystem = svs.tipset.models.xpertenSystemsSingleRow.get(
        'generateSystem'
      );

      if (generateSystem) {
        this.listenTo(
          svs.tipset.collections.boardCollections,
          'boardDataChanged',
          this.updateXpertSystem
        );
      } else {
        this.stopListening(
          svs.tipset.collections.boardCollections,
          'boardDataChanged',
          this.updateXpertSystem
        );
      }
      this.set({
        xperten: xperten,
        xpertenGenSystem: generateSystem
      });
    },

    setXpertenNormal: function(xperten) {
      var generateSystem = svs.tipset.models.xpertenSystems.get(
        'generateSystem'
      );

      if (generateSystem) {
        this.listenTo(
          svs.tipset.collections.matchlist,
          'buttonBet',
          this.updateXpertSystem
        );
      } else {
        this.stopListening(
          svs.tipset.collections.matchlist,
          'buttonBet',
          this.updateXpertSystem
        );
      }

      this.set({
        xperten: xperten,
        xpertenGenSystem: generateSystem
      });
    },

    updateXpertSystem: function() {
      var isSingleRow = svs.tipset.models.play.get('isSingleRow'),
        nrOfHalfHedges = isSingleRow
          ? undefined
          : svs.tipset.collections.matchlist.getNrOfHalfHedges(),
        nrOfFullHedges = isSingleRow
          ? undefined
          : svs.tipset.collections.matchlist.getNrOfFullHedges(),
        genXpertenIsDisabled = true,
        genXpertenInfoText =
          'Gör minst en markering och lämna minst en match ogarderad';

      if (
        nrOfHalfHedges > this.get('xperten').half ||
        nrOfFullHedges > this.get('xperten').full
      ) {
        genXpertenInfoText =
          'Du har gjort för många hel- eller halvgarderingar.';
        genXpertenIsDisabled = true;
      } else {
        genXpertenInfoText =
          'Gör minst en markering och lämna minst en match ogarderad';
        genXpertenIsDisabled = isSingleRow
          ? !svs.tipset.collections.boardCollections.getHasMarksSetByUser()
          : !svs.tipset.collections.matchlist.getHasMarksSetByUser();
      }

      this.set({
        genXpertenIsActive: genXpertenIsDisabled,
        genXpertenInfoText: genXpertenInfoText
      });

      if (!this.get('reloadXperten')) {
        this.trigger('showActionbarXpert');
      } else {
        this.set('reloadXperten', false, { silent: false });
      }
    },

    reloadXperten: function() {
      var isSingleRow = svs.tipset.models.play.get('isSingleRow');
      this.set('reloadXperten', true, { silent: false });
      if (isSingleRow) {
        svs.tipset.models.xpertenSystemsSingleRow.reloadXperten();
      } else {
        svs.tipset.models.xpertenSystems.reloadXperten();
      }
    },

    generateXperten: function() {
      var isSingleRow = svs.tipset.models.play.get('isSingleRow');

      if (isSingleRow) {
        svs.tipset.models.xpertenSystemsSingleRow.generateSystem();
      } else {
        svs.tipset.models.xpertenSystems.generateSystem();
      }
    },

    clearXperten: function() {
      var isSingleRow = svs.tipset.models.play.get('isSingleRow');

      if (isSingleRow) {
        svs.tipset.models.xpertenSystemsSingleRow.clearAll();
      } else {
        svs.tipset.models.xpertenSystems.clearAll();
      }
    },

    clearAll: function() {
      this.clear();
      this.trigger('removeActionBar');
      this.stopListening(
        svs.tipset.collections.matchlist,
        'buttonBet',
        this.updateXpertSystem
      );
      this.stopListening(
        svs.tipset.collections.boardCollections,
        'boardDataChanged',
        this.updateXpertSystem
      );
    }
  });
})(Backbone, _, svs);

 })(window);